import { ReactElement } from "react";
import { Anchor, Flex, Loader, Text, useMantineTheme } from "@mantine/core";

interface Props {
  text: string;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export default function AddOnToggleLink({
  text,
  loading = false,
  disabled = false,
  onClick,
}: Props): ReactElement {
  const theme = useMantineTheme();

  return (
    <Text fw={700} fz="sm">
      <Anchor
        component="button"
        type="button"
        fw={700}
        fz="sm"
        disabled={disabled}
        sx={{
          "&:disabled": {
            color: theme.colors.gray[4],
            cursor: "not-allowed",
            textDecoration: "none",
          },
        }}
        onClick={onClick}
      >
        <Flex align="center" gap={6}>
          {loading && <Loader size={12} color="gray.4" />}
          {text}
        </Flex>
      </Anchor>
    </Text>
  );
}
